import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Panel, Ok, When } from "./Panel";

export const E2ePanel = ({ admin, last, onChange }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const r = await api.post("/email-marketing/launch/e2e-test"); toast[r.data.passed ? "success" : "warning"](r.data.passed ? "All end-to-end checks passed" : "Some checks need attention"); onChange(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Test failed to run"); }
    setBusy(false);
  };
  return (
    <Panel testid="launch-e2e" title="5. End-to-end campaign test" right={<div className="flex items-center gap-2"><When at={last?.at} />
      {admin && <Button size="sm" variant="outline" disabled={busy} onClick={run} data-testid="e2e-run-btn">{busy ? "Running…" : "Run test"}</Button>}</div>}
      sub="Runs the real campaign code in an isolated sandbox (simulated delivery, no customer emails, deleted afterwards): eligibility, segmentation, Unlayer save, scheduling with the send-time consent re-check, webhooks, unsubscribe link, suppression and reporting. Also checks real tracking events from your SendGrid test sends.">
      {last && <div className="grid gap-1 sm:grid-cols-2" data-testid="e2e-result">{last.steps.map((s) => (
        <Ok key={s.key} ok={s.ok} testid={`e2e-step-${s.key}`}>{s.label}{s.detail && !s.ok ? ` — ${s.detail}` : ""}</Ok>))}</div>}
    </Panel>
  );
};
